<template>
  <a-modal :title="this.title" :visible="this.visible" @cancel="cancel" :width="750" @ok="ok">
    <a-form class="baseForm" :form="form" v-bind="formItemLayout" 
      autocomplete="off">
      <a-form-item label="用户名">
        <a-input v-decorator="this.validator.userName" placeholder="请输入用户名"/>
      </a-form-item>      
      <a-form-item label="密码" v-if="!this.record || !this.record.userId">
        <a-input-password v-decorator="this.pwdValidator" placeholder="请输入密码" autocomplete="new-password"/>
      </a-form-item>
      <a-form-item label="确认密码"  v-if="!this.record || !this.record.userId">
        <a-input-password v-decorator="this.pwdChkValidator" placeholder="请输入确认密码" />
      </a-form-item>
      <a-form-item label="姓名">
        <a-input v-decorator="this.validator.userRealName" placeholder="请输入姓名"/>
      </a-form-item>
      <a-form-item label="手机号">
        <a-input v-decorator="this.validator.phone" placeholder="请输入手机号"/>
      </a-form-item>
      <a-form-item label="授予角色">
        <a-select v-decorator="this.validator.userRoles" 
        mode="multiple" placeholder="请选择需要授予角色"
        @deselect="deselectRole">
          <a-select-option v-for="(item) in roleList" :key="item.roleId">
              {{item.roleName}}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="授予场馆">
        <a-select v-decorator="this.validator.userSites" 
        mode="multiple" placeholder="请选择需要授予场馆"
        @deselect="deselectSite">
          <a-select-option v-for="(item) in siteList" :key="item.siteId">
              {{item.siteName}}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="是否启用">
        <a-radio-group v-decorator="this.validator.valid">
          <a-radio :value="1">
            启用
          </a-radio>
          <a-radio :value="0">
            禁用
          </a-radio>         
        </a-radio-group>
      </a-form-item>
      <a-form-item label="性别">
        <a-radio-group v-decorator="this.validator.sex">
          <a-radio :value="1">
            男
          </a-radio>
          <a-radio :value="0">
            女
          </a-radio>         
        </a-radio-group>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import {SAVEUSERINFO,GETROLELIST,GETSITELIST,userInfoForm} from "@/../static/js/API/systemManageApis.js";
import _ from "lodash"; // 引入lodash：封装了诸多对字符串，数组，对象等常见数据类型的处理函数
export default {
  props: ["title", "visible", "record"],
  components: {},
  data() {
    return {
      form: this.$form.createForm(this),
      formItemLayout: {
        labelCol: { span: 6 },
        wrapperCol: { span: 16 }
      },
       formItemLayoutWithOutLabel: {
        wrapperCol: { span: 16, offset: 6 }
      },
      validator: userInfoForm,
      roleList:[],
      siteList:[],
      delRoleList:[],
      delSiteList:[],
      pwdValidator:[
        'userPasswd',    //必填输入控件唯一标志
        {
          rules: [{
            required: true,    //是否必填
            message: "请输入登录密码",     //必填验证提示，
            whitespace: true, //必选时，空格是否被视为错误
            validator:(_rule, value)=>{
              if (value === '') {
                return Promise.reject('请输入登录密码');
              } else {
                let confirmPassword = this.form.getFieldValue("confirmPassword");
                if (confirmPassword !== '') {
                  this.form.validateFields('userPasswd');
                }
        
                return Promise.resolve();
              }
            },
            trigger: 'change',
            },
            {
              pattern: /^(?=.*[a-zA-Z])(?=.*[0-9])[A-Za-z0-9]{6,12}$/,
              message: "密码长度为6-12位,必须由字母、数字组成，区分大小写"
            }
          ]
        }
      ],
      pwdChkValidator:[
        'confirmPassword',    //必填输入控件唯一标志
        {
          rules: [{
            required: true,    //是否必填
           // message: "请输入登录密码",     //必填验证提示，
            whitespace: true, //必选时，空格是否被视为错误
            validator:(_rule, value)=>{
              if (value === '') {
                return Promise.reject('请输入登录密码');
              } else {
                let pwd = this.form.getFieldValue("userPasswd");
                if (value !== pwd) {
                  return Promise.reject('两次输入密码不一致');
                }
        
                return Promise.resolve();
              }
            },
            trigger: 'change',
            },
            {
              pattern: /^(?=.*[a-zA-Z])(?=.*[0-9])[A-Za-z0-9]{6,12}$/,
              message: "密码长度为6-12位,必须由字母、数字组成，区分大小写"
            }
          ]
        }
      ],
    };
  },
  watch:{
    visible(val){
      if(!val)
        return;
      let self = this;
      self.resetFields();
      if(self.record){
        let formItemVal = JSON.parse(JSON.stringify(self.record));
        formItemVal.userName = formItemVal.username;
        if(formItemVal.userRoles && formItemVal.userRoles.length > 0){
            let userRoles = [];
            formItemVal.userRoles.forEach(item=>{
              userRoles.push(item.roleId);
            });
            formItemVal.userRoles = userRoles;
        }
        if(formItemVal.userSites && formItemVal.userSites.length > 0){
            let userSites = [];
            formItemVal.userSites.forEach(item=>{
              userSites.push(item.siteId);
            });
            formItemVal.userSites = userSites;
        }
        self.$nextTick(()=>{
          self.form.setFieldsValue(formItemVal);
        })
      }
    }
  },
  methods: {
    resetFields(){
      this.delRoleList = [];
      this.delSiteList = [];
      this.form.resetFields();
    },
    cancel(e) {
      this.form.resetFields();
      this.$emit("cancel", e);
    },
    ok(e) {
      let self = this;
      e.preventDefault();
      self.form.validateFields((err, values) => {
        if(!err){
         if(self.record.userId)
          values.userId = self.record.userId;
         self.resetUserRoles(values);
         self.resetUserSites(values);
         SAVEUSERINFO(values).then(res =>{
                self.$message.success(res.data);
                if (res.success) {
                  self.resetFields();
                  self.$emit("ok", e); //调用父组件OK方法
                }
         });
        }
      });
    },
    deselectRole(value){
      if(!this.delRoleList.find(i=>i===value))
        this.delRoleList.push(value);
    },
    deselectSite(value){
      if(!this.delSiteList.find(i=>i===value))
              this.delSiteList.push(value);
    },
    resetUserRoles(values){
      let userRoles = [];
      let selUserRoleIds = values.userRoles;
      let existUserRole = this.record.userRoles;
      if(!existUserRole)
        existUserRole = [];
      selUserRoleIds.forEach(item=>{
        let userRole = existUserRole.find(ele => ele.roleId == item);
        if(!userRole){
          let roleInfo = this.roleList.find(ele => ele.roleId == item);
          userRole = {
            roleId:roleInfo.roleId,
          };
        }
        userRoles.push(userRole);
      });
      values.userRoles = userRoles;
      values.delRoles = this.delRoleList.filter(item=>!userRoles.find(ele=>item === ele.roleId));
    },
    resetUserSites(values){
      let userSites = [];
      let selUserSiteIds = values.userSites;
      let existUserSite = this.record.userSites;
      if(!existUserSite)
        existUserSite = [];
      selUserSiteIds.forEach(item=>{
        let userSite = existUserSite.find(ele => ele.siteId == item);
        if(!userSite){
          let siteInfo = this.siteList.find(ele => ele.siteId == item);
          userSite = {
            siteId:siteInfo.siteId,
          };
        }
        userSites.push(userSite);
      });
      values.userSites = userSites;
      values.delSites = this.delSiteList.filter(item=>!userSites.find(ele=>item === ele.siteId));
    },
  },
  mounted(){
    let self = this;
    GETROLELIST().then(res=>{
      self.roleList = res.data;
    });
    GETSITELIST().then(res=>{
      self.siteList = res.data;
    });
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/systemManage/components/userInfoModal.vue